import { BaseModel } from './_base.model';

export class AdvancedReorderSettingModel extends BaseModel {
  id: number;
  productId: number;
  storeId: number;
  outOfStock: boolean;
  buyBox: boolean;
  minusInventory: string;
  minusAllInventory: boolean;
  minusStoreInventory: string;
  minusAllStoresInventory: boolean;
  minusOverstockedStoreInventory: string;
  minusAllStoresOverstockedInventory: boolean;
  minusLocations: number[];
  minusStores: number[];
  minusOverstockedStores: number[];
  minusOpenPurchases: boolean;
  adjustment: number = 0;
  basedOn: number;
  basedOnMonths: string;
  orderFor: number;
  orderForMonths: string;
  manualEntry: number;
  included: boolean;
  subOnly: boolean;
}